import React from 'react'
import {Modal, Image, Row, Col, Alert} from 'react-bootstrap'
import {MdFavorite} from '../ReactIcons/icons'
import CountDown from 'react-simple-countdown'
import {Link} from 'react-router'
import {connect} from 'react-redux'
import {Actions} from 'jumpstate'
import {PersianNumber} from 'react-persian'

import './CampaignBox.css'

class CampaignBox extends React.Component {
  componentWillMount () {
    Actions.loadProducts('eyd_ta_eyd')
  }

  render () {
    const {product} = this.props
    return (
      <Modal show bsSize="large" className="countdown-box">
        <a className="close-modal" onClick={() => this.props.toggler(false)}>X</a>
        <Modal.Title>
          <Alert bsStyle="warning">
            <CountDown
              date="2017-09-10T00:00:00+04:30" // payane eyde ghadir
              className="counter"
              days={{plural: ' روز ', singular: ' روز '}}
              hours=" ساعت "
              mins=" دقیقه "
              segs=" ثانیه "
              onEnd={() => this.props.toggler(false)}
            />
          </Alert>
        </Modal.Title>
        <Modal.Body>
          <Row>
            <Col xs={12} sm={5} md={5} lg={5}>
              <Image src={`${window.location.protocol}//${window.location.host}/popup-mug-tshirt.jpg`} />
            </Col>
            <Col xs={12} sm={7} md={7} lg={7} className="text">
              <h3>اپلیکیشن آیاهو</h3>
              {product.list.length > 0 && <p className="text-justify">
                سلام، عیدتون مبارک! <br />
                راستش مدتیه روی اپلیکیشن آیاهو داشتیم کار می کردیم و کارش داره تمام میشه.

                تصمیم گرفتیم این اپلیکیشن رو واسه کسایی که آیاهو رو <strong>دوست دارن</strong> بفرستیم.
                <br />
                <strong>شما می تونین عشقتون رو با خریدن یه تی شرت یا ماگ ثبت کنین و جزء اولین کسایی باشین که اپلیکیشن آیاهو رو دریافت می کنن. </strong>
                <br />
                راستی! ما فقط
                {' '}<span className="count"><PersianNumber>{product.list[0].count}</PersianNumber></span> تا {product.list[0].title} و
                {' '}<span className="count"><PersianNumber>{product.list[1].count}</PersianNumber></span> تا {product.list[1].title} داریم و فقط تا عید غدیر فرصت ثبت نام هست.
                <br /><br />
                <strong>دوستتون داریم <MdFavorite /></strong>
                <br />
                - تیم آیاهو
              </p>}
              <Link to="/donate" className="btn btn-danger btn-lg btn-block" onClick={() => this.props.toggler(false)}>حمایت می‌کنم <MdFavorite /></Link>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    )
  }
}

CampaignBox.propTypes = {
  toggler: React.PropTypes.func
}

function mapStateToProps (state) {
  return {
    product: state.product
  }
}

export default connect(mapStateToProps)(CampaignBox)



// WEBPACK FOOTER //
// ./src/components/Common/CampaignBox/CampaignBox.js